/* Suggested links between a report's tables (v2.2 data model): the same
 * column name on two tables (ignoring case, spaces and punctuation), on a
 * category / ID / date column -- never on a number that gets summed. Used by
 * the Studio "Tables in this report" panel and by "Build from my data" when
 * several tables are picked. */

export interface LinkField { source_name: string; display_name: string; field_role: string }

export interface SuggestedLink {
  fromDatasetId: string;
  fromField: string;
  toDatasetId: string;
  toField: string;
  why: string;
}

const norm = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, "");
const linkable = (f: LinkField) => f.field_role !== "measure";

export function suggestLinks(tables: string[], fieldsOf: (id: string) => LinkField[], alreadyLinked: Array<[string, string]> = []): SuggestedLink[] {
  const linked = new Set(alreadyLinked.map(([a, b]) => [a, b].sort().join("|")));
  const out: SuggestedLink[] = [];
  for (let i = 0; i < tables.length; i++) {
    for (let j = i + 1; j < tables.length; j++) {
      const a = tables[i];
      const b = tables[j];
      if (linked.has([a, b].sort().join("|"))) continue;
      const fb = new Map(fieldsOf(b).filter(linkable).map((f) => [norm(f.display_name), f]));
      // Prefer ID-like columns, then any shared category.
      const candidates = fieldsOf(a).filter(linkable).sort((x, y) => Number(y.field_role === "identifier") - Number(x.field_role === "identifier"));
      for (const f of candidates) {
        const g = fb.get(norm(f.display_name));
        if (g) {
          out.push({ fromDatasetId: a, fromField: f.source_name, toDatasetId: b, toField: g.source_name, why: `both have “${f.display_name}”` });
          break;
        }
      }
    }
  }
  return out;
}
